namespace RioERP.Web.Modules.Orders.CommonController {
    export interface SerialKeyResponse extends Serenity.SaveResponse {
        SerialKey?: string;
    }
}
